// ITEM40-GROUP-MANAGEMENT-TEST: o botao mais separa criar contato de criar grupo.
import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { useTheme } from "@material-ui/core/styles";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Paper,
  InputBase,
  Tabs,
  Tab,
  Badge,
  IconButton,
  Typography,
  Grid,
  Tooltip,
  Chip} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  Group,
  MoveToInbox as MoveToInboxIcon,
  CheckBox as CheckBoxIcon,
  MessageSharp as MessageSharpIcon,
  AccessTime as ClockIcon,
  Search as SearchIcon,
  Add as AddIcon,
  TextRotateUp,
  TextRotationDown,
  Android as AndroidIcon,
  AccountBalanceWallet as WalletIcon,
} from "@material-ui/icons";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import ToggleButton from "@material-ui/lab/ToggleButton";

import { FilterAltOff, FilterAlt, PlaylistAddCheckOutlined } from "@mui/icons-material";

import NewTicketModal from "../NewTicketModal";
import NewWhatsAppGroupModal from "../NewWhatsAppGroupModal";
import TicketsList from "../TicketsListCustom";
import TabPanel from "../TabPanel";
import { Can } from "../Can";
import TicketsQueueSelect from "../TicketsQueueSelect";
import { TagsFilter } from "../TagsFilter";
import { KanbanLanesFilter } from "../KanbanLanesFilter";
import { UsersFilter } from "../UsersFilter";
import { canUseBroadTicketView } from "../../utils/ticketVisibility";
import { createTicketSearchHandlers } from "../../utils/ticketSearchInput";
import { StatusFilter } from "../StatusFilter";
import { WhatsappsFilter } from "../WhatsappsFilter";
import { Button, Snackbar } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";

import api from "../../services/api";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    minWidth: "auto",
    width: "auto",
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: theme.spacing(1),
  },

  tab: {
    minWidth: "auto",
    width: "auto",
    padding: theme.spacing(0.5, 1),
    borderRadius: 8,
    transition: "0.3s",
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),

    [theme.breakpoints.down("lg")]: {
      fontSize: "0.9rem",
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    [theme.breakpoints.down("md")]: {
      fontSize: "0.75rem",
      padding: theme.spacing(0.25, 0.5),
      marginRight: theme.spacing(0.25),
      marginLeft: theme.spacing(0.25),
    },

    // Específico para monitores de 11-13 polegadas
    '@media (max-width: 1366px)': {
      fontSize: "0.8rem",
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },

  tabPanelItem: {
    minWidth: "24%",
    minHeight: 64,
    fontSize: 11,
    marginLeft: 0,
    transition: "all 0.3s ease",
    fontWeight: 500,
    borderRadius: "8px",
    margin: "0 4px",
    opacity: 0.7,
    "&.Mui-selected": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
    },
    "&:hover": {
      opacity: 1,
      backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.03)" : "rgba(255, 255, 255, 0.05)",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: "23%",
      fontSize: 9,
      padding: theme.spacing(0.5),
    },
    [theme.breakpoints.down('xs')]: {
      minWidth: "22%",
      fontSize: 8,
    },
  },

  tabIndicator: {
    height: 3,
    bottom: 0,
    borderRadius: "3px 3px 0 0",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    transition: "all 0.3s ease",
  },
  tabsBadge: {
    top: "105%",
    right: "55%",
    transform: "translate(45%, 0)",
    whiteSpace: "nowrap",
    borderRadius: "12px",
    padding: "0 8px",
    backgroundColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    color: theme.mode === "light" ? "#FFF" : theme.palette.primary.main,
  },
  ticketOptionsBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: theme.mode === "light" ? "#546e7a" : "#37474f",
    borderRadius: 10,
    border: "none",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: "6px 8px",
  },
  serachInputWrapper: {
    flex: 1,
    height: 40,
    background: theme.palette.total,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    borderColor: "#aaa",
    borderWidth: "1px",
    borderStyle: "solid",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },

  badge: {
    // right: "-10px",
  },

  customBadge: {
    right: "-12px",
    top: "-10px",
    transform: "translate(30%, -30%)",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    borderRadius: "10px",
    padding: "0 6px",
    fontWeight: "bold",
    fontSize: "0.75rem",
    minWidth: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },
  
  modernTabs: {
    minHeight: 68,
    borderRadius: 8,
    backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.02)" : "rgba(255, 255, 255, 0.02)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    padding: "6px 4px", // Reserva altura real para icone, badge e label em ate duas linhas
    margin: "8px 0",
    transition: "all 0.3s ease",
    position: "relative",
  },

  show: {
    display: "block",
  },

  hide: {
    display: "none !important",
  },

  closeAllFab: {
    backgroundColor: "red",
    marginBottom: "4px",
    "&:hover": {
      backgroundColor: "darkred",
    },
  },

  speedDial: {
    position: "absolute",
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    "& .MuiFab-root": {
      width: "40px",
      height: "40px",
      marginTop: "4px",
    },
    "& .MuiFab-label": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },

  snackbar: {
    display: "flex",
    justifyContent: "space-between",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    borderRadius: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.8em",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "1em",
    },
  },

  yesButton: {
    backgroundColor: "#FFF",
    color: "rgba(0, 100, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: theme.spacing(1),
    "&:hover": {
      backgroundColor: "darkGreen",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: "#FFF",
    color: "rgba(139, 0, 0, 1)",
    padding: "4px 4px",
    fontSize: "1em",
    fontWeight: "bold",
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "darkRed",
      color: "#FFF",
    },
    borderRadius: 30,
  },
  filterIcon: {
    marginRight: 6,
    alignSelf: "center",
    color: theme.mode === "light" ? "#0872b9" : "#FFF",
    cursor: "pointer",
  },
  button: {
    height: 30,
    width: 30,
    border: "2px solid",
    borderColor: "#aaa",
    borderRadius: 8,
    marginRight: 8,
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  icon: {
    color: "#aaa",
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  buttonOpen: {
    "& $icon": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
  },
  // Classe padronizada para todos os botões de ação
  standardButton: {
    height: 30,
    width: 30,
    border: "2px solid #aaa",
    borderRadius: 8,
    marginRight: 8,
    padding: 0,
    minWidth: 'auto',
    "&:hover": {
      borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      height: 28,
      width: 28,
      marginRight: 6,
    },
    // Ajuste para monitores pequenos (11-13 polegadas)
    '@media (max-width: 1366px)': {
      height: 28,
      width: 28,
      marginRight: 6,
    },
  },
  activeButton: {
    borderColor: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    borderWidth: "3px",
  },
  standardIcon: {
    color: "#aaa",
    fontSize: 18,
    "&:hover": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
  },
  activeIcon: {
    color: theme.mode === "light" ? theme.palette.primary.main : "#FFF",
  },
}));

const TicketsManagerTabs = () => {
  const theme = useTheme();
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const [searchParam, setSearchParam] = useState("");
  const [noTag, setNoTag] = useState(false);
  const [noKanban, setNoKanban] = useState(false);
  const [tab, setTab] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [newItemChoiceOpen, setNewItemChoiceOpen] = useState(false);
  const [newGroupModalOpen, setNewGroupModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const [sortTickets, setSortTickets] = useState(false);

  const searchInputRef = useRef();
  // A busca geral sempre inclui o conteudo das mensagens. O backend ainda
  // intersecta o resultado com companyId e com o escopo de tickets do usuario.
  const searchOnMessages = true;

  const { user, socket } = useContext(AuthContext);
  const { profile } = user;
  const canShowAllTickets = canUseBroadTicketView(user);
  const { setSelectedQueuesMessage } = useContext(QueueSelectedContext);
  const { tabOpen, setTabOpen } = useContext(TicketsContext);

  const [openCount, setOpenCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [groupingCount, setGroupingCount] = useState(0);
  const [chatbotCount, setChatbotCount] = useState(0);

  const userQueueIds = (user.queues || []).map((q) => q.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedKanbanLanes, setSelectedKanbanLanes] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState([]);
  const [forceSearch, setForceSearch] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [filter, setFilter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [isHoveredAll, setIsHoveredAll] = useState(false);

  // O estado do olho precisa existir tambem no backend. O servidor valida o
  // perfil/permissao no banco antes de liberar qualquer payload amplo.
  useEffect(() => {
    if (!socket) return undefined;
    const syncShowAll = () => {
      socket.emit("setShowAllTickets", {
        enabled: canShowAllTickets && showAllTickets
      });
    };
    syncShowAll();
    socket.on("connect", syncShowAll);
    return () => socket.off("connect", syncShowAll);
  }, [socket, showAllTickets, canShowAllTickets]);

  useEffect(() => {
    if (!socket) return undefined;
    return () => socket.emit("setShowAllTickets", { enabled: false });
  }, [socket]);

  const handleToggleShowAllTickets = () => {
    if (!canShowAllTickets) return;
    if (showAllTickets && location.pathname !== "/tickets") {
      history.push("/tickets");
    }
    setShowAllTickets(previous => !previous);
  };
  const [isHoveredNew, setIsHoveredNew] = useState(false);
  const [isHoveredResolve, setIsHoveredResolve] = useState(false);
  const [isHoveredOpen, setIsHoveredOpen] = useState(false);
  const [isHoveredClosed, setIsHoveredClosed] = useState(false);
  const [isHoveredSort, setIsHoveredSort] = useState(false);

  const [myAttendances, setMyAttendances] = useState(false);
  const [unreadFilter, setUnreadFilter] = useState(false);

  // Referências estáveis para evitar RESET desnecessário na lista de search quando contexto muda
  const searchUsers = useMemo(
    () => myAttendances ? [user.id] : selectedUsers,
    [myAttendances, user.id, selectedUsers]
  );
  const searchStatusFilter = useMemo(
    () => myAttendances ? ["open", "pending", "closed", "chatbot"] : selectedStatus,
    [myAttendances, selectedStatus]
  );

  useEffect(() => {
    setSelectedQueuesMessage(selectedQueueIds);
  }, [selectedQueueIds]);

  useEffect(() => {
    if (!canShowAllTickets) {
      setShowAllTickets(false);
    }
  }, [canShowAllTickets]);

  useEffect(() => {
    // Verificar se há parâmetro 'tab' na URL ao carregar
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "closed"].includes(tabParam)) {
      // Definir a tab principal primeiro
      if (tabParam === "pending") {
        setTab("open"); // "Aguardando" está dentro da tab "open"
      } else if (tabParam === "open") {
        setTab("open");
      } else if (tabParam === "closed") {
        setTab("closed");
      } else if (tabParam === "group") {
        setTab("open"); // "Grupos" está dentro da tab "open"
      }
      // Depois definir a sub-aba (tabOpen)
      setTimeout(() => {
        setTabOpen(tabParam);
      }, 50);
    }
  }, []);

  // Monitorar mudanças na URL para atualizar a aba quando necessário
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabParam = urlParams.get('tab');
    if (tabParam && ["pending", "open", "group", "closed"].includes(tabParam)) {
      // Se o parâmetro tab mudou, atualizar a aba
      if (tabOpen !== tabParam) {
        // Definir a tab principal primeiro
        if (tabParam === "pending") {
          setTab("open"); // "Aguardando" está dentro da tab "open"
        } else if (tabParam === "open") {
          setTab("open");
        } else if (tabParam === "closed") {
          setTab("closed");
        } else if (tabParam === "group") {
          setTab("open"); // "Grupos" está dentro da tab "open"
        }
        // Depois definir a sub-aba (tabOpen) com um pequeno delay
        setTimeout(() => {
          setTabOpen(tabParam);
        }, 100);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
    setForceSearch((previous) => !previous);
  }, [tab]);

  const searchTimeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(searchTimeoutRef.current), []);

  const { handleSearch, handleSearchKeyDown } = createTicketSearchHandlers({
    setSearchParam,
    setTab,
    setForceSearch,
    setFilter
  });

  const handleBack = () => {
    history.push("/tickets");
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    handleBack();
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  const handleSnackbarOpen = () => {
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const CloseAllTicket = async () => {
    try {
      const { data } = await api.post("/tickets/closeAll", {
        status: tabOpen,
        selectedQueueIds,
      });
      handleSnackbarClose();
    } catch (err) {
      console.log("Error: ", err);
    }
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    clearTimeout(searchTimeoutRef.current);
    if (tags.length > 0 && tab !== "search") setTab("search");

    searchTimeoutRef.current = setTimeout(() => {
      setSelectedTags(tags);
      setForceSearch((previous) => !previous);
      if (tags.length > 0) setFilter(false); // FIX PAINEL-RECOLHER
    }, 500);
  };

  const handleSelectedKanbanLanes = (selecteds) => {
    // Só armazena — busca só dispara ao clicar "Filtrar agora"
    const hasNoTag = selecteds.some(lane => lane.id === 0);
    setNoKanban(hasNoTag);
    const laneTagIds = selecteds.filter(lane => lane.id !== 0).map(lane => lane.id);
    setSelectedKanbanLanes(laneTagIds);
  };

  const handleSelectedUsers = (selecteds) => {
    const users = selecteds.map((t) => t.id);

    clearTimeout(searchTimeoutRef.current);

    if (users.length === 0) {
      setForceSearch((previous) => !previous);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSelectedUsers(users);
      setForceSearch((previous) => !previous);
      if (users.length > 0) setFilter(false); // FIX PAINEL-RECOLHER
    }, 500);
  };

  const handleSelectedWhatsapps = (selecteds) => {
    const whatsapp = selecteds.map((t) => t.id);

    clearTimeout(searchTimeoutRef.current);

    if (whatsapp.length === 0) {
      setForceSearch((previous) => !previous);
    } else if (tab !== "search") {
      setTab("search");
    }
    searchTimeoutRef.current = setTimeout(() => {
      setSelectedWhatsapp(whatsapp);
      setForceSearch((previous) => !previous);
      if (whatsapp.length > 0) setFilter(false); // FIX PAINEL-RECOLHER
    }, 500);
  };

  const handleSelectedStatus = (selecteds) => {
    const statusFilter = selecteds.map((t) => t.status);

    clearTimeout(searchTimeoutRef.current);

    if (statusFilter.length === 0) {
      setForceSearch((previous) => !previous);
    } else if (tab !== "search") {
      setTab("search");
    }

    searchTimeoutRef.current = setTimeout(() => {
      setSelectedStatus(statusFilter);
      setForceSearch((previous) => !previous);
    }, 500);
  };

  const applyFilters = () => {
    const hasSelectedFilter = selectedStatus.length > 0 || selectedTags.length > 0 ||
      selectedKanbanLanes.length > 0 || selectedWhatsapp.length > 0 ||
      selectedUsers.length > 0 || noTag || noKanban;
    if (hasSelectedFilter && tab !== "search") setTab("search");
    setForceSearch(prev => !prev);
    setFilter(false); // FIX PAINEL-RECOLHER
  };

  // FIX AVISO-FILTRO: computado a partir do estado real (nao um toggle separado) -
  // garante que o icone e o aviso sempre refletem se ha filtro de verdade aplicado
  const hasActiveFilter = !!searchParam || selectedTags.length > 0 || selectedKanbanLanes.length > 0 ||
    selectedWhatsapp.length > 0 || selectedStatus.length > 0 || selectedUsers.length > 0 ||
    noTag || noKanban || myAttendances;

  useEffect(() => {
    // Ao limpar o ultimo filtro, volta para a lista normal. Se ainda houver
    // outro filtro ativo (por exemplo, coluna + texto), preserva o consolidado.
    if (tab === "search" && !hasActiveFilter) setTab("open");
  }, [hasActiveFilter, tab]);

  const buildActiveFilterDescription = () => {
    const parts = [];
    if (searchParam) parts.push(`busca "${searchParam}"`);
    if (selectedUsers.length > 0) parts.push(`${selectedUsers.length} usuário(s)`);
    if (selectedWhatsapp.length > 0) parts.push(`${selectedWhatsapp.length} conexão(ões)`);
    if (selectedTags.length > 0) parts.push(`${selectedTags.length} tag(s)`);
    if (selectedKanbanLanes.length > 0) parts.push(`${selectedKanbanLanes.length} kanban`);
    if (selectedStatus.length > 0) parts.push(`status`);
    if (noTag) parts.push("sem tag");
    if (noKanban) parts.push("sem kanban");
    if (myAttendances) parts.push("meus atendimentos");
    return parts.join(", ");
  };

  const clearAllFilters = () => {
    // FIX URGENTE: so recria os arrays/dispara nova busca se realmente havia algo selecionado -
    // recriar array vazio quando ja estava vazio some com a lista por um instante a toa
    const hadAnything = hasActiveFilter;
    if (searchParam) setSearchParam("");
    if (selectedTags.length > 0) setSelectedTags([]);
    if (selectedKanbanLanes.length > 0) setSelectedKanbanLanes([]);
    if (selectedWhatsapp.length > 0) setSelectedWhatsapp([]);
    if (selectedStatus.length > 0) setSelectedStatus([]);
    if (selectedUsers.length > 0) setSelectedUsers([]);
    if (noTag) setNoTag(false);
    if (noKanban) setNoKanban(false);
    if (myAttendances) setMyAttendances(false);
    if (searchInputRef.current) searchInputRef.current.value = "";
    setTab("open");
    if (hadAnything) setForceSearch(prev => !prev);
  };

  const handleFilter = () => {
    if (filter) {
      // FIX URGENTE: idem clearAllFilters - so reseta/dispara busca nova se de fato havia filtro ativo
      const hadAnything = hasActiveFilter;
      setFilter(false);
      setTab("open");
      if (searchParam) setSearchParam("");
      if (selectedTags.length > 0) setSelectedTags([]);
      if (selectedUsers.length > 0) setSelectedUsers([]);
      if (selectedWhatsapp.length > 0) setSelectedWhatsapp([]);
      if (selectedStatus.length > 0) setSelectedStatus([]);
      if (myAttendances) setMyAttendances(false);
      if (noTag) setNoTag(false);
      if (noKanban) setNoKanban(false);
      if (hadAnything) setForceSearch((previous) => !previous);
      if (searchInputRef.current) {
        searchInputRef.current.value = "";
      }
    } else {
      setFilter(true);
      // FIX FILTRO-POR-ABA: abrir o painel de filtro nao deve mais forcar a aba de busca sozinho
    }
  };

  const handleMyAttendances = () => {
    const next = !myAttendances;
    setMyAttendances(next);
    if (next) {
      setTab("search");
    } else {
      if (selectedTags.length === 0 && selectedKanbanLanes.length === 0 &&
          selectedWhatsapp.length === 0 && selectedStatus.length === 0 &&
          selectedUsers.length === 0 && !searchParam) {
        setTab("open");
      }
    }
  };

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);

  const handleVisibility = () => {
    setHidden((prevHidden) => !prevHidden);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClosed = () => {
    setOpen(false);
  };

  const tooltipTitleStyle = {
    fontSize: "10px",
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        startWithContactForm={Number.isInteger(Number(user.companyId)) && Number(user.companyId) > 0}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <NewWhatsAppGroupModal
        open={newGroupModalOpen}
        onClose={() => setNewGroupModalOpen(false)}
      />
      <Dialog open={newItemChoiceOpen} onClose={() => setNewItemChoiceOpen(false)}>
        <DialogTitle>Novo atendimento</DialogTitle>
        <DialogContent>O que voce deseja criar?</DialogContent>
        <DialogActions>
          <Button onClick={() => setNewItemChoiceOpen(false)}>Cancelar</Button>
          <Button color="primary" onClick={() => {
            setNewItemChoiceOpen(false);
            setNewTicketModalOpen(true);
          }}>Criar contato</Button>
          {user.profile === "admin" && user.allowGroup && (
            <Button color="primary" variant="contained" onClick={() => {
              setNewItemChoiceOpen(false);
              setNewGroupModalOpen(true);
            }}>Criar grupo</Button>
          )}
        </DialogActions>
      </Dialog>
      <div className={classes.serachInputWrapper}>
        <SearchIcon className={classes.searchIcon} />
        <InputBase
          className={classes.searchInput}
          inputRef={searchInputRef}
          placeholder={i18n.t("tickets.search.placeholder")}
          type="search"
          onChange={handleSearch}
          onKeyDown={handleSearchKeyDown}
        />
        <IconButton
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            borderRadius: "50%",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          variant="contained"
          aria-label="filter"
          className={classes.filterIcon}
          onClick={() => {
            handleFilter();
          }}
        >
          {/* FIX AVISO-FILTRO: icone agora reflete se ha filtro REALMENTE aplicado (nao so o clique do botao) */}
          {hasActiveFilter ? (
            <FilterAlt className={classes.icon} style={{ color: "#d32f2f" }} />
          ) : (
            <FilterAltOff className={classes.icon} />
          )}
        </IconButton>
      </div>

      {filter === true && (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 0, padding: "4px 4px 0" }}>
            <div style={{ minWidth: 0 }}><TagsFilter onFiltered={handleSelectedTags} /></div>
            <div style={{ minWidth: 0 }}><KanbanLanesFilter onFiltered={handleSelectedKanbanLanes} /></div>
            <div style={{ minWidth: 0 }}><WhatsappsFilter onFiltered={handleSelectedWhatsapps} /></div>
            <div style={{ minWidth: 0 }}><StatusFilter onFiltered={handleSelectedStatus} /></div>
            {profile === "admin" && (
              <div style={{ gridColumn: "1 / -1", minWidth: 0 }}><UsersFilter onFiltered={handleSelectedUsers} /></div>
            )}
          </div>
          <div style={{ padding: "4px 10px 8px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                // FIX URGENTE: so dispara nova busca se realmente havia algo selecionado nesses campos
                const hadAnything = selectedTags.length > 0 || selectedKanbanLanes.length > 0 ||
                  selectedWhatsapp.length > 0 || selectedStatus.length > 0 || selectedUsers.length > 0;
                if (selectedTags.length > 0) setSelectedTags([]);
                if (selectedKanbanLanes.length > 0) setSelectedKanbanLanes([]);
                if (selectedWhatsapp.length > 0) setSelectedWhatsapp([]);
                if (selectedStatus.length > 0) setSelectedStatus([]);
                if (selectedUsers.length > 0) setSelectedUsers([]);
                if (hadAnything) setForceSearch(prev => !prev);
              }}
            >
              Limpar
            </Button>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={applyFilters}
            >
              OK — Aplicar
            </Button>
          </div>
        </div>
      )}

      {/* Filtros rápidos de texto */}
      <div style={{ display: "flex", gap: 6, padding: "2px 10px 4px", flexWrap: "wrap" }}>
        <Chip
          label="Ver todos sem tag"
          size="small"
          clickable
          onClick={() => {
            const next = !noTag;
            setNoTag(next);
            // FIX FILTRO-POR-ABA: nao forca mais busca antiga, noTag ja funciona dentro das abas normais
            if (next) { setNoKanban(false); }
            if (next && tab !== "search") setTab("search");
            setForceSearch(f => !f);
          }}
          color={noTag ? "primary" : "default"}
          variant={noTag ? "default" : "outlined"}
          style={{ fontSize: 11, height: 22 }}
        />
        <Chip
          label="Ver todos sem kanban"
          size="small"
          clickable
          onClick={() => {
            const next = !noKanban;
            setNoKanban(next);
            // FIX FILTRO-POR-ABA: nao forca mais busca antiga, noKanban ja funciona dentro das abas normais
            if (next) { setNoTag(false); }
            if (next && tab !== "search") setTab("search");
            setForceSearch(f => !f);
          }}
          color={noKanban ? "primary" : "default"}
          variant={noKanban ? "default" : "outlined"}
          style={{ fontSize: 11, height: 22 }}
        />
        <Chip
          icon={<WalletIcon style={{ fontSize: 14 }} />}
          label="Meus Atendimentos"
          size="small"
          clickable
          onClick={handleMyAttendances}
          color={myAttendances ? "primary" : "default"}
          variant={myAttendances ? "default" : "outlined"}
          style={{ fontSize: 11, height: 22 }}
        />
        {tabOpen === "open" && (
          <Chip
            label="Não lidas"
            size="small"
            clickable
            onClick={() => setUnreadFilter(f => !f)}
            color={unreadFilter ? "primary" : "default"}
            variant={unreadFilter ? "default" : "outlined"}
            style={{ fontSize: 11, height: 22 }}
          />
        )}
      </div>

      {/* FIX AVISO-FILTRO: faixa visivel avisando que ha filtro ativo, mesmo com o painel fechado */}
      {hasActiveFilter && (
        <div style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "6px 12px", backgroundColor: "#fff3e0",
          borderBottom: "1px solid #ffcc80"
        }}>
          <FilterAlt style={{ color: "#e65100", fontSize: 18 }} />
          <span style={{ fontSize: 13, color: "#e65100", fontWeight: 600 }}>
            Filtro ativo{buildActiveFilterDescription() ? `: ${buildActiveFilterDescription()}` : ""} — nem todas as conversas estão sendo exibidas
          </span>
          <Button
            size="small"
            onClick={clearAllFilters}
            style={{ marginLeft: "auto", color: "#e65100", fontWeight: 600, textTransform: "none" }}
          >
            Limpar filtro
          </Button>
        </div>
      )}

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <Grid container alignItems="center">
          <Grid item>
            <Can
              role={user.profile}
              perform="tickets-manager:showall"
              yes={() => (
<Badge
  color="primary"
  invisible={
    !isHoveredAll ||
    isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed
  }
  badgeContent={"Todos"}
  classes={{ badge: classes.tabsBadge }}
>
  <ToggleButton
    onMouseEnter={() => setIsHoveredAll(true)}
    onMouseLeave={() => setIsHoveredAll(false)}
    className={`${classes.standardButton} ${showAllTickets ? classes.activeButton : ''}`}
    value="uncheck"
    selected={showAllTickets}
    onChange={handleToggleShowAllTickets}
  >
    {showAllTickets ? (
      <VisibilityIcon className={`${classes.standardIcon} ${classes.activeIcon}`} />
    ) : (
      <VisibilityOffIcon className={classes.standardIcon} />
    )}
  </ToggleButton>
</Badge>
              )}
            />
            <Snackbar
              open={snackbarOpen}
              onClose={handleSnackbarClose}
              message={i18n.t("tickets.inbox.closedAllTickets")}
              ContentProps={{
                className: classes.snackbar,
              }}
              action={
                <>
                  <Button
                    className={classes.yesButton}
                    size="small"
                    onClick={CloseAllTicket}
                  >
                    {i18n.t("tickets.inbox.yes")}
                  </Button>
                  <Button
                    className={classes.noButton}
                    size="small"
                    onClick={handleSnackbarClose}
                  >
                    {i18n.t("tickets.inbox.no")}
                  </Button>
                </>
              }
            />
<Badge
  color="primary"
  invisible={
    isHoveredAll ||
    !isHoveredNew ||
    isHoveredResolve ||
    isHoveredOpen ||
    isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.newTicket")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => setIsHoveredNew(true)}
    onMouseLeave={() => setIsHoveredNew(false)}
    className={classes.standardButton}
    onClick={() => {
      setNewItemChoiceOpen(true);
    }}
  >
    <AddIcon className={classes.standardIcon} />
  </IconButton>
</Badge>
{user.profile === "admin" && (
  <Badge
    color="primary"
    invisible={
      isHoveredAll ||
      isHoveredNew ||
      !isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed
    }
    badgeContent={i18n.t("tickets.inbox.closedAll")}
    classes={{ badge: classes.tabsBadge }}
  >
    <IconButton
      onMouseEnter={() => setIsHoveredResolve(true)}
      onMouseLeave={() => setIsHoveredResolve(false)}
      className={classes.standardButton}
      onClick={handleSnackbarOpen}
    >
      <PlaylistAddCheckOutlined className={classes.standardIcon} />
    </IconButton>
  </Badge>
)}
{/* Botão "Abertos" */}
<Badge
  invisible={
    !(
      tab === "open" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredClosed &&
      !isHoveredSort
    ) && !isHoveredOpen
  }
  badgeContent={i18n.t("tickets.inbox.open")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => {
      setIsHoveredOpen(true);
      setHoveredButton("open");
    }}
    onMouseLeave={() => {
      setIsHoveredOpen(false);
      setHoveredButton(null);
    }}
    className={`${classes.standardButton} ${
      (tab === "open" || isHoveredOpen) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "open")}
  >
    <MoveToInboxIcon
      className={`${classes.standardIcon} ${
        (tab === "open" || isHoveredOpen) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{/* Botão "Resolvidos" */}
<Badge
  color="primary"
  invisible={
    !(
      tab === "closed" &&
      !isHoveredAll &&
      !isHoveredNew &&
      !isHoveredResolve &&
      !isHoveredOpen &&
      !isHoveredSort
    ) && !isHoveredClosed
  }
  badgeContent={i18n.t("tickets.inbox.resolverd")}
  classes={{ badge: classes.tabsBadge }}
>
  <IconButton
    onMouseEnter={() => {
      setIsHoveredClosed(true);
      setHoveredButton("closed");
    }}
    onMouseLeave={() => {
      setIsHoveredClosed(false);
      setHoveredButton(null);
    }}
    className={`${classes.standardButton} ${
      (tab === "closed" || isHoveredClosed) ? classes.activeButton : ''
    }`}
    onClick={() => handleChangeTab(null, "closed")}
  >
    <CheckBoxIcon
      className={`${classes.standardIcon} ${
        (tab === "closed" || isHoveredClosed) ? classes.activeIcon : ''
      }`}
    />
  </IconButton>
</Badge>

{tab !== "closed" && tab !== "search" && (
  <Badge
    color="primary"
    invisible={
      !isHoveredSort ||
      isHoveredAll ||
      isHoveredNew ||
      isHoveredResolve ||
      isHoveredOpen ||
      isHoveredClosed
    }
    badgeContent={!sortTickets ? "Crescente" : "Decrescente"}
    classes={{ badge: classes.tabsBadge }}
  >
    <ToggleButton
      onMouseEnter={() => setIsHoveredSort(true)}
      onMouseLeave={() => setIsHoveredSort(false)}
      className={`${classes.standardButton} ${sortTickets ? classes.activeButton : ''}`}
      value="uncheck"
      selected={sortTickets}
      onChange={() => setSortTickets((prevState) => !prevState)}
    >
      {!sortTickets ? (
        <TextRotateUp className={`${classes.standardIcon} ${sortTickets ? classes.activeIcon : ''}`} />
      ) : (
        <TextRotationDown className={`${classes.standardIcon} ${classes.activeIcon}`} />
      )}
    </ToggleButton>
  </Badge>
)}

{/* Movido o seletor de filas para a mesma linha dos botões */}
<span className="MuiBadge-root">
  <TicketsQueueSelect
    selectedQueueIds={selectedQueueIds}
    userQueues={user?.queues}
    onChange={(values) => setSelectedQueueIds(values)}
  />
</span>
          </Grid>
        </Grid>
      </Paper>

      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          scrollButtons="auto"
          TabIndicatorProps={{ className: classes.tabIndicator }}
          className={classes.modernTabs}
        >
          {/* AUTOMAÇÕES - apenas para usuarios com showFlow habilitado */}
          {(user.profile === "admin" || user.showFlow === "enabled") && <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 6, paddingBottom: 6, minHeight: 44 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={chatbotCount}
                    color="primary"
                  >
                    <AndroidIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "chatbot" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      lineHeight: "14px",
                      fontWeight: tabOpen === "chatbot" ? 700 : 500,
                      color: tabOpen === "chatbot" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    Automações
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"chatbot"}
            name="chatbot"
            classes={{ root: classes.tabPanelItem }}
          />}

          {/* AGUARDANDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 6, paddingBottom: 6, minHeight: 44 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={pendingCount}
                    color="primary"
                  >
                    <ClockIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      lineHeight: "14px",
                      fontWeight: tabOpen === "pending" ? 700 : 500,
                      color: tabOpen === "pending" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.pendingHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"pending"}
            name="pending"
            classes={{ root: classes.tabPanelItem }}
          />


          {/* ATENDENDO */}
          <Tab
            label={
              <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 6, paddingBottom: 6, minHeight: 44 }}>
                <Grid item>
                  <Badge
                    overlap="circular"
                    max={999}
                    classes={{ badge: classes.customBadge }}
                    badgeContent={openCount}
                    color="primary"
                  >
                    <MessageSharpIcon
                      style={{
                        fontSize: 20,
                        color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      }}
                    />
                  </Badge>
                </Grid>
                <Grid item>
                  <Typography
                    style={{
                      marginLeft: 8,
                      fontSize: 11,
                      lineHeight: "14px",
                      fontWeight: tabOpen === "open" ? 700 : 500,
                      color: tabOpen === "open" ? theme.palette.primary.main : "inherit",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {i18n.t("ticketsList.assignedHeader")}
                  </Typography>
                </Grid>
              </Grid>
            }
            value={"open"}
            name="open"
            classes={{ root: classes.tabPanelItem }}
          />


          {/* GRUPOS */}
          {user.allowGroup && (
            <Tab
              label={
                <Grid container alignItems="center" justifyContent="center" style={{ position: "relative", paddingTop: 6, paddingBottom: 6, minHeight: 44 }}>
                  <Grid item>
                    <Badge
                      overlap="circular"
                      max={999}
                      classes={{ badge: classes.customBadge }}
                      badgeContent={groupingCount}
                      color="primary"
                    >
                      <Group
                        style={{
                          fontSize: 20,
                          color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item>
                    <Typography
                      style={{
                        marginLeft: 8,
                        fontSize: 11,
                        lineHeight: "14px",
                        fontWeight: tabOpen === "group" ? 700 : 500,
                        color: tabOpen === "group" ? theme.palette.primary.main : "inherit",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {i18n.t("ticketsList.groupingHeader")}
                    </Typography>
                  </Grid>
                </Grid>
              }
              value={"group"}
              name="group"
              classes={{ root: classes.tabPanelItem }}
            />
          )}

        </Tabs>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            showAll={canShowAllTickets && showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setOpenCount(val)}
            countWithUnreadOnly={true}
            unreadFilter={unreadFilter}
            style={applyPanelStyle("open")}
            setTabOpen={setTabOpen}
            myAttendances={myAttendances}
            searchParam={searchParam}
            searchOnMessages={searchOnMessages}
            users={selectedUsers}
            whatsappIds={selectedWhatsapp}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noTag={noTag ? "true" : ""}
            noKanban={noKanban ? "true" : ""}
          />
          <TicketsList
            status="pending"
            selectedQueueIds={selectedQueueIds}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            showAll={canShowAllTickets && showAllTickets}
            updateCount={(val) => setPendingCount(val)}
            countByTickets={true}
            style={applyPanelStyle("pending")}
            setTabOpen={setTabOpen}
            searchParam={searchParam}
            searchOnMessages={searchOnMessages}
            users={selectedUsers}
            whatsappIds={selectedWhatsapp}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noTag={noTag ? "true" : ""}
            noKanban={noKanban ? "true" : ""}
          />
          {user.allowGroup && (
            <TicketsList
              status="group"
              showAll={canShowAllTickets && showAllTickets}
              sortTickets={sortTickets ? "ASC" : "DESC"}
              selectedQueueIds={selectedQueueIds}
              updateCount={(val) => setGroupingCount(val)}
              countWithUnreadOnly={true}
              style={applyPanelStyle("group")}
              setTabOpen={setTabOpen}
              searchParam={searchParam}
              searchOnMessages={searchOnMessages}
              users={selectedUsers}
              whatsappIds={selectedWhatsapp}
              tags={selectedTags}
              kanbanTags={selectedKanbanLanes}
              noTag={noTag ? "true" : ""}
              noKanban={noKanban ? "true" : ""}
            />
          )}
          {(user.profile === "admin" || user.showFlow === "enabled") && <TicketsList
            status="chatbot"
            showAll={canShowAllTickets && showAllTickets}
            sortTickets={sortTickets ? "ASC" : "DESC"}
            selectedQueueIds={selectedQueueIds}
            updateCount={(val) => setChatbotCount(val)}
            countByTickets={true}
            style={applyPanelStyle("chatbot")}
            setTabOpen={setTabOpen}
            searchParam={searchParam}
            searchOnMessages={searchOnMessages}
            users={selectedUsers}
            whatsappIds={selectedWhatsapp}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noTag={noTag ? "true" : ""}
            noKanban={noKanban ? "true" : ""}
          />}
        </Paper>
      </TabPanel>

      <TabPanel value={tab} name="closed" className={classes.ticketsWrapper}>
        <TicketsList
          status="closed"
          showAll={canShowAllTickets && showAllTickets}
          selectedQueueIds={selectedQueueIds}
          setTabOpen={setTabOpen}
		  searchParam={searchParam}
		  searchOnMessages={searchOnMessages}
		  users={selectedUsers}
		  whatsappIds={selectedWhatsapp}
		  tags={selectedTags}
		  kanbanTags={selectedKanbanLanes}
		  noTag={noTag ? "true" : ""}
		  noKanban={noKanban ? "true" : ""}
		  forceSearch={forceSearch}
        />
      </TabPanel>

      <TabPanel value={tab} name="search" className={classes.ticketsWrapper}>
        {profile === "admin" && (
          <>
            <TicketsList
              statusFilter={searchStatusFilter}
              searchParam={searchParam}
              showAll={!myAttendances}
              tags={selectedTags}
              kanbanTags={selectedKanbanLanes}
              noKanban={noKanban}
              noTag={noTag}
              users={searchUsers}
              selectedQueueIds={selectedQueueIds}
              whatsappIds={selectedWhatsapp}
              forceSearch={forceSearch}
              searchOnMessages={searchOnMessages}
              status="search"
              sortTickets="DESC"
              filterAcrossStatuses={hasActiveFilter}
            />
          </>
        )}

        {profile === "user" && (
          <TicketsList
            statusFilter={searchStatusFilter}
            searchParam={searchParam}
            showAll={false}
            tags={selectedTags}
            kanbanTags={selectedKanbanLanes}
            noKanban={noKanban}
            noTag={noTag}
            users={searchUsers}
            selectedQueueIds={selectedQueueIds}
            whatsappIds={selectedWhatsapp}
            forceSearch={forceSearch}
            searchOnMessages={searchOnMessages}
            status="search"
            sortTickets="DESC"
            filterAcrossStatuses={hasActiveFilter}
          />
        )}
      </TabPanel>
    </Paper >
  );
};

export default TicketsManagerTabs;
